import { render, staticRenderFns } from "./WaveForm.vue?vue&type=template&id=3e1ddac0&"
import script from "./WaveForm.vue?vue&type=script&lang=ts&"
export * from "./WaveForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports